// Rich-text renderer: line breaks into paragraphs, simple "- " / "* " bullets.
// Moved verbatim from DecisionEnginePage.js during Phase 2 of the System
// Consolidation — no logic or visual changes.
import React from 'react';

export const RichText = ({ text, className = '', testId }) => {
  if (!text) return null;
  const lines = String(text).replace(/\r\n/g, '\n').split('\n');
  const blocks = [];
  let para = [];
  let bullets = [];

  const flushPara = () => {
    if (para.length) {
      blocks.push({ type: 'p', content: para.join(' ') });
      para = [];
    }
  };
  const flushBullets = () => {
    if (bullets.length) {
      blocks.push({ type: 'ul', items: [...bullets] });
      bullets = [];
    }
  };

  for (const raw of lines) {
    const line = raw.trim();
    if (!line) {
      flushPara();
      flushBullets();
      continue;
    }
    const bulletMatch = line.match(/^[-*•]\s+(.*)$/);
    if (bulletMatch) {
      flushPara();
      bullets.push(bulletMatch[1]);
    } else {
      flushBullets();
      para.push(line);
    }
  }
  flushPara();
  flushBullets();

  return (
    <div className={`space-y-2 ${className}`} data-testid={testId}>
      {blocks.map((b, i) =>
        b.type === 'ul' ? (
          <ul key={i} className="list-disc pl-5 space-y-1">
            {b.items.map((it, j) => (
              <li key={j} className="leading-relaxed">{it}</li>
            ))}
          </ul>
        ) : (
          <p key={i} className="leading-relaxed">{b.content}</p>
        )
      )}
    </div>
  );
};
